export default __webpack_public_path__ + "static/media/GoodHabitz_white.bccc5893.svg";